export default function (elem: HTMLElement) {
    let target = elem.dataset["gsTarget"];
    if (!target) {
        throw new Error("data-gs-toggle='add-more' needs target through data-gs-target");

    }
    let targetElem = document.querySelector(target) as HTMLElement;
    if (!targetElem) {
        throw new Error("data-gs-target can not be found");
    }
    let containerElem = targetElem;
    if (containerElem.tagName.toUpperCase() == "TABLE") {
        let tBodies = (containerElem as HTMLTableElement).tBodies;
        if (tBodies.length > 1) {
            throw new Error("multiply tbody in table, please apply data-gs-toggle='add-more' on tbody");
        }
        containerElem = tBodies[0] as HTMLElement;
    }
    let max = 10000; //this should be large enough
    if ("gsAddMoreMax" in elem.dataset) {
        max = +elem.dataset["gsAddMoreMax"];
        if (isNaN(max)) {
            throw new Error("data-gs-add-more-max is invlid number");
        }
    }
    if (containerElem.childElementCount === 0) {
        throw new Error("target doesn't have any childelement. Can't copy");
    } else if (containerElem.childElementCount >= max) {
        elem.style.display = "none";
    } else {
        elem.addEventListener("click", (e) => {
            e.preventDefault();
            let lastRowElem = containerElem.lastElementChild;
            let newRowElem = lastRowElem.cloneNode(true) as HTMLElement;
            containerElem.appendChild(newRowElem);
            if (containerElem.childElementCount >= max) {
                elem.style.display = "none";
            }
            var inputElems = newRowElem.querySelectorAll('input');
            for (let i = 0; i < inputElems.length; i++) {
                updateInputName(inputElems[i]);
                clearValue(inputElems[i]);
            }
            var selectElems = newRowElem.querySelectorAll('select');
            for (let i = 0; i < selectElems.length; i++) {
                updateInputName(selectElems[i]);
            }
            var textareaElems = newRowElem.querySelectorAll('textarea');
            for (let i = 0; i < textareaElems.length; i++) {
                updateInputName(textareaElems[i]);
                clearValue(textareaElems[i]);
            }
            var autoIncreaseElem = newRowElem.querySelector('[data-gs-add-more-auto-increase');
            if (autoIncreaseElem) {
                let currentValue = +autoIncreaseElem.textContent;
                if (!isNaN(currentValue)) {
                    let nextValue = currentValue + 1;
                    autoIncreaseElem.textContent = nextValue.toString();
                }
            }
            emitEvent(targetElem, newRowElem);
        });
    }
    function updateInputName(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) {
        let name = input.name;
        let parts = /^([^\d]*)(\d+)([^\d]*)$/.exec(name);
        if (parts) {
            parts[2] = (+parts[2] + 1).toString();
            let newName = parts[1] + parts[2] + parts[3];
            input.name = newName;
        }
    }
    function clearValue(input: HTMLInputElement | HTMLTextAreaElement) {
        if (input.type === "checkbox" || input.type === "radio") {
            return;
        }
        if ("gsAddMoreSkipClear" in input.dataset) {
            return;
        } else {
            input.value = '';
        }
    }

    function emitEvent(targetElem: HTMLElement, newRowElem: HTMLElement) {
        var event = new CustomEvent('gs-add-more-new-row', { 'detail': newRowElem });
        targetElem.dispatchEvent(event);
    }
}